import { Box, BoxProps, styled } from '@mui/material';
import { ProjectStatus } from '../types/Project';

interface StatusLabelProps extends BoxProps {
  status: ProjectStatus | 'online' | 'offline' | 'abnormal';
}

const StatusLabel: React.ComponentType<StatusLabelProps> = styled(
  Box,
)<StatusLabelProps>`
  ${({ theme }) => ({ ...theme.externalTypography.body3Bold })}
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 100px;
  height: 22px;
  background: ${({ theme, status }) => {
    switch (status) {
      case 'open':
      case 'online':
        return '#78DC00';
      case 'inprogress':
        return theme.color.primary.$80;
      case 'completed':
        return theme.color.secondary.$80;
      case 'overdue':
      case 'abnormal':
        return '#FF6800';
      case 'offline':
        return theme.color.secondary.$40;
      case 'suspend':
        return theme.color.secondary.$100;
      default:
        return theme.color.primary.$80;
    }
  }};
  padding: 0 8px;
  border-radius: 4px;
`;

export default StatusLabel;
